import type { Story } from '@/store/story-types'

export const PET_SUPPLY_STORE_NEW3_STORY: Story = {
  id: 'pet-supply-store-new3',
  name: 'PawPal — Pet Supply Store',
  narrative: 'A modern pet supply store with product catalog, cart, and checkout. Features cute pet-themed design with warm colors for pet owners to shop conveniently.',
  goals: ['Browse pet supply catalog by category', 'View product details with images and descriptions', 'Add items to cart and manage quantities', 'Complete checkout with shipping and payment'],
  lifecycle: 'ready',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'completed', elementCount: 8, linkedPageId: 'home', description: 'Landing page with hero, product grid, and navigation' },
    { id: 'pg-detail', title: 'Product Detail', order: 1, status: 'completed', elementCount: 5, linkedPageId: 'product-detail', description: 'Product detail with image, specs, and add-to-cart' },
    { id: 'pg-cart', title: 'Cart', order: 2, status: 'completed', elementCount: 4, linkedPageId: 'cart', description: 'Cart with item list, quantity controls, and total' },
    { id: 'pg-checkout', title: 'Checkout', order: 3, status: 'completed', elementCount: 4, linkedPageId: 'checkout', description: 'Checkout form with shipping and payment info' },
  ],
  bddScenarios: [
    {
      id: 'bdd-1', name: 'Browse Pet Products',
      description: 'Pet owner browses the product catalog',
      steps: [
        { type: 'given', text: 'the user opens the pet supply store' },
        { type: 'when', text: 'the home page loads' },
        { type: 'then', text: 'product cards with images, names, and prices are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2', name: 'View Product Detail',
      description: 'User views a product in detail',
      steps: [
        { type: 'given', text: 'the user is browsing products', linkedPageId: 'home' },
        { type: 'when', text: 'they tap a product card' },
        { type: 'then', text: 'product detail page shows full info and add-to-cart', linkedPageId: 'product-detail' },
      ],
    },
    {
      id: 'bdd-3', name: 'Add to Cart',
      description: 'User adds a pet product to cart',
      steps: [
        { type: 'given', text: 'the user is on product detail', linkedPageId: 'product-detail' },
        { type: 'when', text: 'they tap Add to Cart' },
        { type: 'then', text: 'the item is added and cart badge updates', linkedFlowId: 'addToCart' },
      ],
    },
    {
      id: 'bdd-4', name: 'Complete Checkout',
      description: 'User completes the purchase',
      steps: [
        { type: 'given', text: 'the user has items in cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they fill checkout form and submit' },
        { type: 'then', text: 'order is confirmed and cart is cleared', linkedPageId: 'checkout' },
      ],
    },
  ],
}
